<template>
  <layout-main-inner
    showBack
    :title="$route.query.msgId ? '编辑内容':'新增内容'">
    <div slot="action">
      <el-button
        type="primary"
        @click="editMessage(2)">完成</el-button>
    </div>
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">基本信息</template>
      <el-form
        ref="ruleForm"
        style="max-width: 720px;margin: 0 auto;"
        :model="info"
        :rules="rules"
        label-width="120px">
        <el-form-item
          label="内容标题："
          prop="title">
          <el-input
            v-model="info.title"
            show-word-limit
            :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="内容说明：">
          <el-input
            v-model="info.name"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 4}"
            show-word-limit
            :maxlength="150"></el-input>
        </el-form-item>
        <el-form-item
          label="内容详情："
          prop="content">
          <desc-images
            v-model="info.content"
            :edit="true"></desc-images>
        </el-form-item>
      </el-form>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import DescImages from '@/components/public/desc-images.vue'
import Portal from '@/service/portal'
export default {
  name: 'WxappMessageEdit',
  components: { DescImages },
  data() {
    return {
      info: { msgId: null, title: '', name: '', contentType: 0, content: [] },
      rules: {
        title: [
          { required: true, message: '请输入内容标题', trigger: 'blur' }
        ],
        name: [
          { min: 3, max: 30, message: '请输入内容说明', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请上传图文详情', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    if (this.$route.query.msgId) {
      this.getmessage()
    }
  },
  methods: {
    getmessage() {
      this.loading = true
      Portal.getmessage({ ... this.$route.query })
        .then(res => {
          this.loading = false
          const { result, message, content } = res.data
          if ([0].includes(result)) {
            this.info = { ...res.data, content: this.$splitImage(content) }
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    editMessage() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          const { msgId, content } = this.info
          const dispatch = msgId ? 'updatemessage' : 'addmessage'
          Portal[dispatch]({
            ...this.info,
            content: this.$stringfyImage(content),
            isShowImage: 1,
            status: 2
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.$router.go(-1)
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    }
  }
}
</script>
